

<div class="container" *ngIf="!showProfil">
    <div *ngIf="possedecompte">
        <app-connection-compte (connected)="show($event)"></app-connection-compte>
        <div class="row mb-2 mdpreset">
            <p >Pas de compte ? <button class="btnsubmit" (click)="creerCompte();">Créer un compte</button></p>
        </div>    
    </div>
    <div *ngIf="!possedecompte">
        <app-creer-compte ></app-creer-compte>
        <div class="row mb-2 mdpreset">
            <p>Déjà un compte ? <button class="btnsubmit" (click)="creerCompte();">Se connecter</button></p>
        </div>    
    </div>
</div>
<div class="container" *ngIf="showProfil">
    <div>
        <app-profil></app-profil>
    </div>
</div>